import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HLSFragmentSelectorType, } from '@aws-sdk/client-kinesis-video-archived-media';
import { Environment } from 'internal-config';
import { useState } from 'react';
/* A bare bones video tab to display video from one hardcoded stream via the AWS SDK GetMedia API.
* https://docs.aws.amazon.com/kinesisvideostreams/latest/APIReference/API_dataplane_GetMedia.html
 * The purpose of this is to determine whether video may be retrieved from KVS where the stream
 * is not comliant with the AWS streaming protocols, and whether the client can reassemble into
 * a local stream that is playable in the browser
 */
const { region } = Environment;
const StreamARN = `arn:aws:kinesisvideo:ap-southeast-2:983633894134:stream/i3012-dev-Firekart_RMS_Linux-Firekart_RMS_Linux_Camera_1/1786073868200`;
const StreamNameA = 'i3012-dev-Firekart_RMS_Linux-TAPO_A';
const StreamNameB = 'i3012-dev-Firekart_RMS_Linux-TAPO_B';
const StreamNameC = 'i3012-dev-Firekart_RMS_Linux-Firekart_RMS_Linux_Camera_1';
const STABLE_CLIP_DISCOVERY_START_UTC = new Date('2026-09-06 17:46:00 UTC').toUTCString(); // '2026-09-01T17:30:00.000Z'
const STABLE_CLIP_DISCOVERY_START = new Date(STABLE_CLIP_DISCOVERY_START_UTC);
const externalBaseUrl = 'https://tmux.firekart.com/';
const internalBaseUrl = 'http://localhost:8080/';
const baseUrl = internalBaseUrl;
// Returns seconds buffered ahead of the current playhead.
const getBufferedAheadSeconds = (video) => {
    const { buffered, currentTime } = video;
    for (let i = 0; i < buffered.length; i += 1) {
        const start = buffered.start(i);
        const end = buffered.end(i);
        if (currentTime >= start && currentTime <= end) {
            return Math.max(0, end - currentTime);
        }
    }
    return 0;
};
// Flips between producer and server timestamp selectors.
const getAlternateSelectorType = (selectorType) => {
    return selectorType === HLSFragmentSelectorType.PRODUCER_TIMESTAMP ? HLSFragmentSelectorType.SERVER_TIMESTAMP : HLSFragmentSelectorType.PRODUCER_TIMESTAMP;
};
// Extracts the timestamp used for ordering from a fragment.
const getFragmentTimestamp = (fragment, selectorType) => {
    const rawTimestamp = selectorType === HLSFragmentSelectorType.SERVER_TIMESTAMP ? fragment.ServerTimestamp : fragment.ProducerTimestamp;
    return rawTimestamp instanceof Date ? rawTimestamp : null;
};
// Video lab tab that discovers historical windows and plays them through hls.js.
export const VideoMediaLabTab = ({}) => {
    const [selectedStream, setSelectedStream] = useState(StreamNameA);
    const format = 'mp4';
    const startTimestamp = STABLE_CLIP_DISCOVERY_START_UTC;
    const videoUrl = `${baseUrl}getMedia?streamName=${encodeURIComponent(selectedStream)}&startTimestamp=${encodeURIComponent(startTimestamp)}&format=${format}`;
    return (_jsxs("div", { children: [_jsxs("div", { children: [_jsxs("label", { children: [_jsx("input", { type: "radio", value: StreamNameA, checked: selectedStream === StreamNameA, onChange: () => setSelectedStream(StreamNameA) }), "Stream A"] }), _jsxs("label", { style: { marginLeft: 16 }, children: [_jsx("input", { type: "radio", value: StreamNameB, checked: selectedStream === StreamNameB, onChange: () => setSelectedStream(StreamNameB) }), "Stream B"] }), _jsxs("label", { style: { marginLeft: 16 }, children: [_jsx("input", { type: "radio", value: StreamNameC, checked: selectedStream === StreamNameC, onChange: () => setSelectedStream(StreamNameC) }), "Stream C"] })] }), _jsxs("div", { children: ["Stream: ", selectedStream] }), _jsxs("div", { children: ["Start Timestamp: ", startTimestamp] }), _jsxs("div", { children: [_jsx("video", { controls: true, width: 640, src: videoUrl }), _jsxs("div", { children: [_jsx("strong", { children: "Proxy URL:" }), " ", videoUrl] })] })] }));
};
